import { jwtDecode } from 'jwt-decode';
export function authRepositoryFactory({ auth0Client, auth0Config: { extranetConnection, smagConnection }, }) {
    async function doLogin() {
        try {
            await auth0Client.loginWithRedirect();
        }
        catch (error) {
            localStorage.clear();
            throw error;
        }
    }
    async function doExtranetLogin() {
        try {
            await auth0Client.loginWithRedirect({
                authorizationParams: {
                    connection: extranetConnection,
                },
            });
            localStorage.setItem('afterLoginPath', '/');
        }
        catch (error) {
            localStorage.clear();
            throw error;
        }
    }
    async function doSmagLogin() {
        try {
            await auth0Client.loginWithRedirect({
                authorizationParams: { connection: smagConnection },
            });
        }
        catch (error) {
            localStorage.clear();
            throw error;
        }
    }
    async function doRegister() {
        try {
            await auth0Client.loginWithRedirect({
                authorizationParams: { screen_hint: 'signup' },
            });
        }
        catch (error) {
            localStorage.clear();
            throw error;
        }
    }
    async function doLogout(opts) {
        localStorage.removeItem('targetShoppingListId');
        localStorage.removeItem('targetMembershipNumber');
        localStorage.removeItem('targetCustomer');
        localStorage.removeItem('afterLoginPath');
        const returnToComputed = opts?.returnTo || window.location.origin;
        await auth0Client.logout({
            logoutParams: { returnTo: returnToComputed },
        });
    }
    async function doAuth0Callback() {
        await auth0Client.handleRedirectCallback();
    }
    async function isAuthenticated() {
        return auth0Client.isAuthenticated();
    }
    async function loadUserAuth0Token({ forceRefresh }) {
        // We need the previous token because Auth0 would happily and silently get a token from another user if the user in
        // the auth0 login domain changed, leading to a corrupted state in the front, with
        const previousToken = await auth0Client.getTokenSilently({ cacheMode: 'cache-only' });
        const accessToken = await auth0Client.getTokenSilently(forceRefresh ? { cacheMode: 'off' } : {});
        if (!accessToken)
            throw new Error('No access token returned by Auth0 SPA client'); // This should not happen unless cache-only option is activated
        // NOTE: this is not optimal at all, we reparse the token everytime (and this is use very often, multiple times by page change)
        const parsedAccessToken = jwtDecode(accessToken);
        if (previousToken) {
            let parsedPreviousAccessToken = undefined;
            try {
                parsedPreviousAccessToken = jwtDecode(previousToken);
            }
            catch (e) {
                // pass, an erroneous previous token is unexpected but we'd just ignore it
                // eslint-disable-next-line no-console
                console.warn('cant parse previous token, ignoring it: ', e.message ?? 'no message provided');
            }
            if (parsedPreviousAccessToken && parsedPreviousAccessToken.userEmail !== parsedAccessToken.userEmail) {
                throw new Error('User has changed. Must log out in in again');
            }
        }
        return { scopes: parsedAccessToken.scope.split(' '), accessToken };
    }
    async function getUserAuth0Token() {
        return loadUserAuth0Token({ forceRefresh: false });
    }
    async function refreshUserAuth0Token() {
        return loadUserAuth0Token({ forceRefresh: true });
    }
    return {
        doLogin,
        doExtranetLogin,
        doSmagLogin,
        doRegister,
        doLogout,
        doAuth0Callback,
        isAuthenticated,
        getUserAuth0Token,
        refreshUserAuth0Token,
    };
}
//# sourceMappingURL=auth.repository.factory.js.map